import React, { useState, useEffect } from "react";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import { Link } from "react-router-dom";
// import { SidebarData } from "./SidebarData";
import "../App.css";
import { IconContext } from "react-icons";
import { getUserDetails, clearAllData } from "../Utility/AsyncStorage";
import { useNavigate } from "react-router-dom";
import { Tooltip } from 'react-tooltip'
import { SidebarData, fetchSidebarData } from "./SidebarData";


function SideBar() {
  const [sidebar, setSidebar] = useState(false);


  var userDetail = getUserDetails();
  const navigate = useNavigate();

  const showSidebar = () => setSidebar(!sidebar);
  // console.log("userDetail", userDetail)

  const handleSignout = async () => {
    console.log("signout")
    await clearAllData()
    navigate("/")
  }

  useEffect(() => {
    fetchSidebarData(); // Call this before using SidebarData
  }, []);


  return (
    <>
      <IconContext.Provider value={{ color: "undefined" }}>
        <div className="navbar" style={{
          display: 'inline-flex', flexDirection: "row", alignItems: "center", backgroundColor: 'white', width: "100%",
          //     position: "fixed", zIndex: 2, 
          // boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)"
        }}>
          <Link to="#" className="menu-bars" style={{ display: (userDetail.role === "MACHINE INCHARGE" ? "none" : "inline-flex") }}>
            <FaIcons.FaBars onClick={showSidebar} />
          </Link>
          <div className='comp-name' style={{ marginLeft: 30 }}>
            <img style={{ width: "60px", marginRight: 10 }}
              src={require("../Assets/T_LOGO_1.jpg")}
              alt="logo"
            />
            <div className="companyName">
              <h2 className="dashboard-header-h2"> ITL Industries Ltd.</h2>
              <h5 className='dashboard-header-h5'>(a BSE Listed, ISO 9001:2015 Certified Company)</h5>
            </div>
          </div>
           {/* <img style={{ width: "250px", marginLeft: 10 }}
              src={require("../Assets/itl-logo.png")}
              alt="logo"
            /> */}
        </div>

        <nav className={sidebar ? "nav-menu active" : "nav-menu"}>
          <ul className="nav-menu-items" onClick={showSidebar}>
            {/* <li className="navbar-toggle"> */}
            <div style={{ display: "inline-flex", alignItems: "center", justifyContent: "flex-start", margin: " 20px 0 20px 10px" }}>
              <Link to="#" className="menu-bars" >
                <AiIcons.AiOutlineClose />
              </Link>
            </div>

            <div style={{ marginBottom: 30 }}>
              <h4 style={{ marginBottom: 5, textAlign: "center", color: "rgb(5 74 108)", fontSize: 16, fontWeight: 700 }}>{userDetail.company_name}</h4>
              <h6 style={{ textAlign: "center", color: "rgb(5 74 108)", fontSize: 14, fontWeight: 400 }}>{userDetail.name}</h6>
            </div>



            {SidebarData.map((item, index) => {
              return (
                <li key={index} className={item.cName}>
                  <Link to={item.path}>
                    {item.icon}
                    <span>{item.title}</span>
                  </Link>
                </li>
              );
            })}


            <div style={{ position: "absolute", bottom: 10, left: 10, fontSize: 20, padding: 20 }}
              data-tooltip-id="my-tooltip"
              data-tooltip-content="Signout"
              onClick={handleSignout}>
              <AiIcons.AiOutlineLogout />

              <Tooltip id="my-tooltip" />
            </div>
          </ul>
        </nav>
      </IconContext.Provider>
    </>
  );
}

export default SideBar;
